import { createI18n } from "vue-i18n"
import messages from "@/languages/config/messages"

const i18n = new createI18n({
  globalInjection: true,
  legacy: false,
  locale: localStorage.getItem("hotel-one-blueprint-locale") || "en",
  fallbackLocale: "bg",
  messages
})

export default i18n
